import React, { useEffect, useState,} from 'react'
import '../styles/program.scss'
import _ from 'lodash'
import moment from 'moment'
import ShowtimeProgram from './ShowtimeProgram';




import { useLocation } from "react-router-dom";
import LOCALE from '../../datepicker/DatePickerLocale'





export default function ShowtimeListItems({ cinema, take, currentStartDate, nextWeek, previousWeek, lastShowtimeDa, firstWeek, lastWeek, nextValidWeek }) {
 
   
   
    const allShowtimeTypes = []
      //  console.log(currentStartDate, 'current start date')
   
   
  

    //console.log(date, 'DATE')
    const [dimNextArrow, setDimNextArrow] = useState(false)
    const [dimBackArrow, setDimBackArrow] = useState(currentStartDate === moment() ? true : false)
   
    // const querystrings = getParams();

    //let base = querystrings.base && querystrings.base.toLowerCase()

   

    const showtimesByDate = _.groupBy(cinema.validShowtimes, (showtime) => {
       // console.log(showtime)
        //if (base === 'true' ? showtime.movieId === movie.id && showtime.showInfo.enabled && showtime.type && !_.find(showtimeTypes, showtime.type)
        //    : showtime.showInfo.enabled && showtime.type && !_.find(showtimeTypes, showtime.type)) //needs if condition on queryparams
        //    showtimeTypes.push(showtime.type);
        if (showtime._eventTypeNo !== 0) {
            allShowtimeTypes.push(showtime.type == null ? null : showtime.type[0])
        }
        return /*base === 'true' ? showtime.movieId === movie.id && moment(showtime.dateTime).format('YYYY-MM-DD') :*/ moment(showtime.dateTime).format('YYYY-MM-DD'); // needs if condition on queryparams
    });

    function toFindDuplicates(showtimeTypes) {
        const uniqueElements = new Set(showtimeTypes);

        showtimeTypes.filter((item) => {
            if (uniqueElements.has(item)) {

            } else {
                return item;
            }
        });

        return [...new Set(uniqueElements)];
    }
    const showtimeTypes = toFindDuplicates(allShowtimeTypes)
   // console.log(showtimeTypes, 'showtime types')

    let shoss = [{}]
    const generateShowtimesOnDate = (showtimesOnDate, MAX,) => {
        let s = showtimesOnDate && showtimesOnDate.length
        // let tt = MAX - s

     //   console.log(showtimesOnDate, 'showtime on date')

        return showtimesOnDate ? _.map(showtimesOnDate, (showtime, index) => {

            shoss.push(showtime)
         //   console.log(showtime, 'showtime', index)
            return <ShowtimeProgram showtime={showtime} index={index}
                date_text={moment(showtime.dateTime).format('LT')} showtimeTypes={showtimeTypes} />;

            return shoss



        })
            :
            Array.from({ length: MAX })
                .map((_, index) => (
                    <div className="Showtime hidden_Showtime" key={index} style={{ marginTop: '3px' }}></div>
                )
                )
        // return <div className="Showtime" style={{ backgroundColor: '#327365', marginTop: '3px' }}>fff</div>          
    }

    let startDate = currentStartDate;
    if (!startDate && cinema.validShowtimes.length > 0) startDate = moment(cinema.validShowtimes[0].dateTime);


    const generateWeekSchedule = (startDateOrg ) => {
          startDate = startDateOrg.clone(); // we don't want to mutate it

        const weekScheduleItems = [];
     //   console.log(showtimesByDate, 'showtimes by date')
        // console.log(movie.validShowtimes, 'movie validshowtimes')

        let showtimesOnDateMAX = 0
        for (var i = 0; i < take; i++) {
            const x = showtimesByDate[startDate.format('YYYY-MM-DD')] /*_.map(showtimesByDate, (shows) => { return shows[startDate.format('YYYY-MM-DD')] })*/
           // console.log(x, 'x')
            if (x != null && x.length > showtimesOnDateMAX) showtimesOnDateMAX = x.length
             startDate.add(1, 'day')
        }

          startDate = startDateOrg.clone(); // we don't want to mutate it
       // console.log(startDate.format('YYYY-MM-DD'), 'start date')
       // console.log(showtimesOnDateMAX, 'MAX showtimes')

        for (var i = 0; i < take; i++) {
            const date = moment(startDate);
            // console.log(date, 'date')
            const formattedDate = _.capitalize(date.locale("da").format('ddd D/M'))
            const today = date.isSame(moment(), 'day') ? 'I dag' : ''
            const tomorrow = date.isSame(moment().add(1, 'day'), 'day') ? 'I morgen' : ''
            const showtimesOnDate = showtimesByDate[startDate.format('YYYY-MM-DD')] /*_.map(showtimesByDate, (shows) => { return shows[startDate.format('YYYY-MM-DD')] })*/
         //  console.log(today, 'today')
          //  console.log(showtimesOnDate, 'showtimes on date')

            weekScheduleItems.push(

                <div key={startDate} className="showtimes-on-date">

                    <h4 className="date" style={{ fontFamily: 'oswald', fontWeight: 400, letterSpacing:'0.3px' }}>{today || tomorrow || formattedDate}</h4>
                    <div>{generateShowtimesOnDate(showtimesOnDate, showtimesOnDateMAX, )}  </div>

                    {/*<div> {generateNoShowtimeDiv(showtimesOnDateMAX, showtimesOnDate)} </div>*/}

                </div>

            )

            startDate.add(1, 'day');
        }

        return weekScheduleItems

    }
  

    let firstShowtime = moment(cinema.validShowtimes[0].dateTime).format('YYYY-MM-DD')

    let str = currentStartDate.format('YYYY-MM-DD')
    let ff = cinema.validShowtimes
    let fg = ff[ff.length - 1]

    var widths = [0, 431, 850];
    let lastShowtime = moment(fg.dateTime).format('YYYY-MM-DD')

    const currentEndDate = currentStartDate.clone().add((take - 1), 'days');

    /*-------------FINDING OUT if there are showtimes in currentWeek------*/
    let tw = 0
    useEffect(() => {

        _.map(cinema.validShowtimes, showtime => {

            if ((moment(showtime.dateTime).isBetween(currentStartDate, currentEndDate)) && tw == 0) {
                tw = 1
            }

        })

    })


    /*-------------FINDING OUT WHEN TO DISABLE NEXT ARROW------*/
    let nextWeekStrD = currentStartDate.clone().add(take, 'days');
    let nextWeekEndD = currentEndDate.clone().add(take, 'days')


    let nw = 0
    useEffect(() => {
        _.map(cinema.validShowtimes, showtime => {

            if ((moment(showtime.dateTime).isBetween(nextWeekStrD, nextWeekEndD) || (moment(showtime.dateTime).isAfter(nextWeekEndD) && tw == 1)) && nw == 0) {
                nw = 1
            }
            //}
        })
        if (nw == 0) setDimNextArrow(true)
        else setDimNextArrow(false)

    })

    /*----------FINDING OUT WHEN TO DISABLE BACK ARROW----------*/
    let lastWeekStrD = currentStartDate.clone().subtract(take, 'days')
    let lastWeekEndD = currentEndDate.clone().subtract(take, 'days')


    let lw = 0
    useEffect(() => {
        let td = currentStartDate
        let tm = moment().add(1, 'days')
        let isCrntDisT = td.isSame(tm, 'day')

        _.map(cinema.validShowtimes, showtime => {

            if ((moment(showtime.dateTime).isBetween(lastWeekStrD, lastWeekEndD) ||
                (moment(showtime.dateTime).isBefore(currentStartDate) && isCrntDisT) || (moment(showtime.dateTime).isSame(lastWeekEndD, 'day'))
                || (moment(showtime.dateTime).isBefore(lastWeekStrD) && tw == 1)) && lw == 0) {
                lw = 1
            }

        })
      //  console.log(lw, 'lw')
        if (lw == 0) setDimBackArrow(true)
        else setDimBackArrow(false)

    })

    let datejump = []
    _.map(cinema.validShowtimes, showtime => {

        let check = moment(showtime.dateTime).format('YYYY-MM-DD') >= currentStartDate.clone().add((take), 'days').format('YYYY-MM-DD')
        if (check === true) {
            datejump.push(showtime.dateTime)

            return showtime.dateTime
        }

    })


    let dateBack = []


    _.map(cinema.validShowtimes, showtime => {

        let check = moment(showtime.dateTime).format('YYYY-MM-DD') < currentStartDate.clone().format('YYYY-MM-DD')
        if (check === true) {

            dateBack.push(showtime.dateTime.slice(0, 10))

            return showtime.dateTime
        }

    });
    var date1 = moment(str);
    var date2 = moment(datejump[0]);
    var date3 = moment(lastShowtime)
    var date4 = moment(dateBack[dateBack.length - 1])

    var differ = date2.diff(date1, 'days')
    var forrigeDiffer = date4.diff(date1, 'days')


    var diff = date1.diff(date3, 'days')

    useEffect(() => {
    //    //generateWeekSchedule(currentStartDate)
    //    console.log('use eff')
    //    console.log(startDate, 'start date')
    }, [currentStartDate])

   // console.log(dimBackArrow, 'dim back arrow')
    //console.log(dimNextArrow, 'dim next arrow')

    return (
        <>
            <div className='bio_name_container'>
                <p className='bio_name'>{cinema.bio_name}</p>
            </div>
            <section className='schedule'>
                
                <div className='showtimeScheduleWeek' >
               
                  {generateWeekSchedule(currentStartDate)}
               
                </div>
                <div style={{ textAlign:'center' }}>
                <div className='inBetweenShowtimes' >

                    {shoss.length <= 1 ?
                        lastShowtime < str ?

                            <div style={{ color: 'white', display: 'flex',cursor:'pointer' }} className="previousShowBtn" onClick={() => lastWeek(diff)}>
                                <span style={{ marginLeft: window.innerWidth < widths[1] ? '0px' : '7px', marginTop: /*window.innerWidth < widths[1] ? '15px' : */'15px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                                        <mask id="mask0_2290_5396"  maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="18">
                                            <rect width="21" height="17.6129" transform="matrix(-1 0 0 1 21 0)" fill="white" />
                                        </mask>
                                        <g mask="url(#mask0_2290_5396)">
                                            <path d="M17.6128 -4.7417L5.41924 8.80669L17.6128 22.3551" stroke="white" stroke-width="2.94118" />
                                        </g>
                                    </svg>
                                </span>
                                    <p style={{ letterSpacing: '0.3px' }}>Sidste Visning</p>
                                </div>
                                :
                                firstShowtime < str ?
                                    <div className="leftRightShowtimes" >
                                    <div style={{display:'flex'}} className="previousShowBtn" onClick={() => nextValidWeek(forrigeDiffer)} >
                                        <span style={{ marginLeft: window.innerWidth < widths[1] ? '0px' : '7px', marginTop:  '15px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                                                <mask id="mask0_2290_5396" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="18">
                                                    <rect width="21" height="17.6129" transform="matrix(-1 0 0 1 21 0)" fill="white" />
                                                </mask>
                                                <g mask="url(#mask0_2290_5396)">
                                                    <path d="M17.6128 -4.7417L5.41924 8.80669L17.6128 22.3551" stroke="white" stroke-width="2.94118" />
                                                </g>
                                            </svg>
                                        </span>
                                            <p style={{ letterSpacing: '0.3px' }}>Forrige visninger</p>
                                        </div>
                                        <div className="nextShowBtn" onClick={() => firstWeek(differ)}>
                                            <p style={{ letterSpacing:'0.3px' }}>Næste visninger</p>
                                            <span className="ty" style={{  marginTop: /*window.innerWidth < widths[1] ? '10px' : */'15px' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                                                <mask id="mask0_2290_5393" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="18">
                                                    <rect width="21" height="17.6129" fill="white" />
                                                </mask>
                                                <g mask="url(#mask0_2290_5393)">
                                                    <path d="M3.38721 -4.7417L15.5808 8.80669L3.38721 22.3551" stroke="white" stroke-width="2.94118" />
                                                </g>
                                            </svg>
                                            </span>
                                        </div>

                                    </div>

                                    :
                                <div style={{ display: 'flex', cursor: 'pointer', color: 'white',  width:'140px' }} className="" onClick={() => firstWeek(differ)}>
                                        <p style={{ marginLeft: '7px', letterSpacing: '0.3px' } }>Næste visninger</p>
                                    <span style={{ marginLeft: window.innerWidth < widths[1] ? '0px' : '7px', marginTop: /*window.innerWidth < widths[1] ? '15px' :*/ '15px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                                            <mask id="mask0_2290_5393" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="18">
                                                <rect width="21" height="17.6129" fill="white" />
                                            </mask>
                                            <g mask="url(#mask0_2290_5393)">
                                                <path d="M3.38721 -4.7417L15.5808 8.80669L3.38721 22.3551" stroke="white" stroke-width="2.94118" />
                                            </g>
                                        </svg>
                                    </span>
                                </div>

                        : ''}
                </div>
                </div> 
               
                <div className='moviesArrows'>
                    <div className={dimNextArrow === false ? 'week-nav ' : 'week-nav disabled'} onClick={nextWeek} >
                        <span>
                            <svg className="moviesRightArr" style={{
                                position: window.innerWidth < widths[1] ? 'absolute' : '', top: window.innerWidth < widths[1] ? '10px' : '',
                                right: window.innerWidth < widths[1] ? '0%' : '40%'
                            }} xmlns="http://www.w3.org/2000/svg" width="18" height="30" viewBox="0 0 18 30" fill="none">
                                <path d="M4.25 5L14.25 15L4.25 25" stroke="white" stroke-width="2" stroke-linecap="round" />
                            </svg>
                           
                            {/*<svg className="moviesRightArr"*/}
                            {/*    style={{ position: window.innerWidth < widths[1] ? 'absolute' : '', top: window.innerWidth < widths[1] ? '10px' : '',
                                right: window.innerWidth < widths[1] ? '0%' : '40%'}}*/}
                            {/*    opacity={dimNextArrow === true && window.innerWidth < widths[1] ? '0.3' : ''} width={window.innerWidth < widths[1] ? '11' : '16'}*/}
                            {/*    marginbottom={window.innerWidth < widths[1] ? '5px' : '0'} viewBox="0 0 16 29" fill="none"*/}
                            {/*    xmlns="http://www.w3.org/2000/svg">*/}
                            {/*    <path fillRule="evenodd" clipRule="evenodd" d="M13.7929 14.5L0.646484 1.35359L1.35359 0.646484L15.2071 14.5L1.35359 28.3536L0.646484 27.6465L13.7929 14.5Z" fill="white" />*/}
                            {/*</svg>*/}
                        </span>
                    </div>
                    <div className={dimBackArrow === false ? 'week-nav ' : 'week-nav disabled'}  onClick={previousWeek} style={{marginTop:'0px'} }>
                        <span>
                            <svg className="moviesLeftArr" style={{
                                position: window.innerWidth < widths[1] ? 'absolute' : '', top: window.innerWidth < widths[1] ? '10px' : '', right: window.innerWidth < widths[1] ? '' : '43%',
                                left: window.innerWidth < widths[1] ? '0%' : ''
                            }} xmlns="http://www.w3.org/2000/svg" width="18" height="30" viewBox="0 0 18 30" fill="none">
                                <path d="M14.25 5L4.25 15L14.25 25" stroke="white" stroke-width="2" stroke-linecap="round" />
                            </svg>
                          
                     </span>
                    </div>
                </div>
            </section>
            <section className="showtimeTypeContainer" style={{ marginTop: window.innerWidth < widths[1] ? '-6px' : '',color:'white' }}>

                <div className='showtimeTypes' style={{ marginTop: window.innerWidth < widths[1]  ? '20px' : ''} }>
                {showtimeTypes.map((types,index) => (
                    <span style={{ marginRight:'20px' } }>
                        <span className='showtime-type-icon'>{index+1}</span>
                        <span style={{ letterSpacing: '0.3px' }}>{ types.name}</span>
                    </span>
                )

                )}
                </div>

            </section>
            <hr style={{ borderBottom: 'none', opacity: '0.1', margin: '28px 0px' }} />

        </>
    )
}